import { Avatar, Box, Button, CircularProgress, Grid } from "@mui/material";
import { capitalize } from "./helpers";
import { toast } from "react-toastify";

export const handleNumberInput = (e, formikname, formik, allowDecimal) => {
  const value = e.target.value;
  const decimalRegex = /^\d*\.?\d{0,2}$/;
  const numberRegex = /^[0-9]*$/;

  const re = allowDecimal ? decimalRegex : numberRegex;

  if (value === "" || re.test(value)) {
    formik.setFieldValue(formikname, value);
  }
};


export const formatOrderStatus = (status) => {
    const statusMap = {
      "out-for-delivery": "Out For Delivery",
      "in-progress": "In Progress",
      "pending": "Pending",
      "delivered": "Delivered",
      "cancelled": "Cancelled",
      "dispatched": "Dispatched",
      "on-the-way": "On the way",
      "arrived": "Arrived"
      // Add more mappings as needed
    };
  
    return statusMap[status] || capitalize(status || "Unknown");
  };

  export const validateImage = (file, extension, imageSize) => {
    // let sizeIntoByte = imageSize ? (imageSize * 1024 * 1024) : (2 * 1024 * 1024)
    imageSize = imageSize || 2
    let validate = false
    if (file) {
        if (extension?.includes(file?.type)) {
            validate = true
            // if (sizeIntoByte >= file.size) {
            //     validate = true
            // } else {
            //     toast.error(`Image must be less than ${imageSize}mb`, {
            //         toastId: "maximumSizeLimit",
            //         autoClose: 2000
            //     })
            // }
        } else {
            toast.error(`Only the following formats are accepted: ${extension?.join(', ')}`, {
                toastId: "extionsionLimit"
            })
        }
    }

    return validate

}

export const handleCorruptValidate = (files) => {
    const promises = [];

    files.forEach(file => {
        promises.push(new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = function (e) {
                const img = new Image();
                img.onload = function () {
                    resolve(file);
                };
                img.onerror = function () {
                    toast.error("Image is corrupted: " + file.name);
                };
                img.src = e.target.result;
            };
            reader.onerror = function () {
                reject("Error: Failed to read the file: " + file.name);
            };
            reader.readAsDataURL(file);
        }));
    });

    return Promise.all(promises);
};

export const formatTime = (time) => {
    if (!time) return 'Invalid Time';
    const newTime = new Date(time);
    let hours = newTime.getUTCHours();
    let minutes = newTime.getUTCMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert 0 hours to 12
    minutes = String(minutes).padStart(2, '0');
    return `${hours}:${minutes} ${ampm}`;
  };


  export function modifyReactSelectToString(allData) {
    let temp = []
    if (allData) {
        temp = allData?.map((data) => data?.value)
    }
    return temp
}

export function modifyDataForReactSelect(allData, labelValue, value) {
    if (allData?.length > 0) {
        let newData = allData?.map((o) => ({
            value: o?.[value],
            label: o?.[labelValue]
        }))
        return newData
    }
}

